// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/cat2.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section.num1 {
    position: relative;
    width: 100%;
    height: 100vh;
    background-color: #121827;
    color: white;
    overflow: hidden;
  }
  
  .SelfIntroductionWord {
    position: absolute;
    left: 100%;
    font-family: "Arial", sans-serif;
    font-weight: bold;
    white-space: nowrap;
    animation: flyLeft linear infinite;
    opacity: 0;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
            user-select: none;
  }
  
  @keyframes flyLeft {
    50% {
        opacity: 0;
    }
    90% {
      opacity: 0.4;
      transform: translateX(-100vw);
    }
    100% {
      opacity: 0.05;
      transform: translateX(-120%);
    }
  }
  
  @media screen and (max-width: 760px){
    @keyframes flyLeft {
        50% {
            opacity: 0;
        }
        90% {
          opacity: 0;
          transform: translateX(-100vw);
        }
        100% {
          opacity: 0.22;
          transform: translateX(-120%);
        }
      }
  }

  .SelfIntroductiocard-container {
    position: absolute;
    top: 50%;
    left: 75%;
    transform: translate(-50%, -50%);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border: 0.2px solid #73797c;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 24px;
    height: 60%;
    min-height: 490px;
    max-height: 550px;
    width: 40%;
    max-width: 420px;
    min-width: 386px;
    z-index: 50;
    opacity: 0.9;
    display: flex;
    flex-direction: column; /* Stack items vertically */
    justify-content: center; /* Center items vertically */
    align-items: center; 
  }
  
  .SelfIntroductiocard-image {
    width: 180px;
    height: 180px;
    border: 3.8px solid;
    border-radius: 50%;
    border-color: #E4B300;
    margin: 0 auto 16px;
    object-fit: cover;
    display: block;
  }
  
  .SelfIntroductiocard-content {
    text-align: center;
    border-radius: 12px;
    background-color: #121827;
    padding: 16px;
    opacity: 1;
    max-width: 430px;
  }
  
  .SelfIntroductiocard-content h1 {
    font-size: 1.5rem;
    font-weight: bold;
    color: #F4CC00;
    margin-bottom: 16px;
  }
  
  .SelfIntroductiocard-content p {
    color: #CCD5DB;
    margin-bottom: 16px;
  }
  
  .SelfIntroductiocard-buttons {
    display: flex;
    justify-content: center;
    gap: 16px;
  }
  
  .SelfIntroductiocard-buttons a {
    text-decoration: none;
    color: #121827;
    background-color: #F4CC00;
    padding: 8px 16px;
    font-size: 0.875rem;
    font-weight: 500;
    border-radius: 8px;
    transition: background-color 0.3s ease;
  }
  
  .SelfIntroductiocard-buttons a:hover {
    background-color: #E4B300;
  }
  
  @media (max-width: 800px) {
    .SelfIntroductiocard-container {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0.99;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/App/SelfIntroduction.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,gCAAgC;IAChC,iBAAiB;IACjB,mBAAmB;IACnB,kCAAkC;IAClC,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;YAIjB,iBAAiB;EAC3B;;EAEA;IACE;QACI,UAAU;IACd;IACA;MACE,YAAY;MACZ,6BAA6B;IAC/B;IACA;MACE,aAAa;MACb,4BAA4B;IAC9B;EACF;;EAEA;IACE;QACI;YACI,UAAU;QACd;QACA;UACE,UAAU;UACV,6BAA6B;QAC/B;QACA;UACE,aAAa;UACb,4BAA4B;QAC9B;MACF;EACJ;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,yDAA0C;IAC1C,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB,EAAE,2BAA2B;IACnD,uBAAuB,EAAE,4BAA4B;IACrD,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,QAAQ;MACR,SAAS;MACT,gCAAgC;MAChC,aAAa;IACf;EACF","sourcesContent":[".section.num1 {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100vh;\r\n    background-color: #121827;\r\n    color: white;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .SelfIntroductionWord {\r\n    position: absolute;\r\n    left: 100%;\r\n    font-family: \"Arial\", sans-serif;\r\n    font-weight: bold;\r\n    white-space: nowrap;\r\n    animation: flyLeft linear infinite;\r\n    opacity: 0;\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n     -khtml-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n  }\r\n  \r\n  @keyframes flyLeft {\r\n    50% {\r\n        opacity: 0;\r\n    }\r\n    90% {\r\n      opacity: 0.4;\r\n      transform: translateX(-100vw);\r\n    }\r\n    100% {\r\n      opacity: 0.05;\r\n      transform: translateX(-120%);\r\n    }\r\n  }\r\n  \r\n  @media screen and (max-width: 760px){\r\n    @keyframes flyLeft {\r\n        50% {\r\n            opacity: 0;\r\n        }\r\n        90% {\r\n          opacity: 0;\r\n          transform: translateX(-100vw);\r\n        }\r\n        100% {\r\n          opacity: 0.22;\r\n          transform: translateX(-120%);\r\n        }\r\n      }\r\n  }\r\n\r\n  .SelfIntroductiocard-container {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 75%;\r\n    transform: translate(-50%, -50%);\r\n    background-image: url('./images/cat2.jpg');\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    border: 0.2px solid #73797c;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    padding: 24px;\r\n    height: 60%;\r\n    min-height: 490px;\r\n    max-height: 550px;\r\n    width: 40%;\r\n    max-width: 420px;\r\n    min-width: 386px;\r\n    z-index: 50;\r\n    opacity: 0.9;\r\n    display: flex;\r\n    flex-direction: column; /* Stack items vertically */\r\n    justify-content: center; /* Center items vertically */\r\n    align-items: center; \r\n  }\r\n  \r\n  .SelfIntroductiocard-image {\r\n    width: 180px;\r\n    height: 180px;\r\n    border: 3.8px solid;\r\n    border-radius: 50%;\r\n    border-color: #E4B300;\r\n    margin: 0 auto 16px;\r\n    object-fit: cover;\r\n    display: block;\r\n  }\r\n  \r\n  .SelfIntroductiocard-content {\r\n    text-align: center;\r\n    border-radius: 12px;\r\n    background-color: #121827;\r\n    padding: 16px;\r\n    opacity: 1;\r\n    max-width: 430px;\r\n  }\r\n  \r\n  .SelfIntroductiocard-content h1 {\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n    color: #F4CC00;\r\n    margin-bottom: 16px;\r\n  }\r\n  \r\n  .SelfIntroductiocard-content p {\r\n    color: #CCD5DB;\r\n    margin-bottom: 16px;\r\n  }\r\n  \r\n  .SelfIntroductiocard-buttons {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 16px;\r\n  }\r\n  \r\n  .SelfIntroductiocard-buttons a {\r\n    text-decoration: none;\r\n    color: #121827;\r\n    background-color: #F4CC00;\r\n    padding: 8px 16px;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    border-radius: 8px;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .SelfIntroductiocard-buttons a:hover {\r\n    background-color: #E4B300;\r\n  }\r\n  \r\n  @media (max-width: 800px) {\r\n    .SelfIntroductiocard-container {\r\n      top: 50%;\r\n      left: 50%;\r\n      transform: translate(-50%, -50%);\r\n      opacity: 0.99;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
